import React from 'react';
import { FieldArray } from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

import FieldIterables from './FieldIterables.jsx';

const FieldArrayIterables = ({
  name,
  children,
  tail,
  push,
  pushTitle,
  paginate,
}) => (
  <FieldArray name={name}>
    {(helpers) => (
      <>
        <FieldIterables
          name={name}
          tail={tail}
          helpers={helpers}
          paginate={paginate}
        >
          {children}
        </FieldIterables>
        {push !== undefined && (
          <button
            type="button"
            className="btn btn-primary btn-block"
            onClick={() => helpers.push(push)}
          >
            <FA icon={faPlus} className={pushTitle ? 'mr-1' : ''} />
            {pushTitle}
          </button>
        )}
      </>
    )}
  </FieldArray>
);

export default FieldArrayIterables;
